import { mapUrlToPageLogProps, Page } from 'components/Logs'
import Main from './TaxInvoicesMain'
import Show from './TaxInvoicesShow'
import Edit from './TaxInvoicesEdit'

export default {
  Main,
  Show,
  Edit,
  Logs: mapUrlToPageLogProps(({ params }) => ({
    title: 'Nota Fiscal',
    entity: 'service_tax_invoice',
    entityId: params.taxInvoiceId,
  }))(Page),
}
